"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitAtLeast = exports.Wait = void 0;
const lodash_1 = require("lodash");
function Wait(m1, m2) {
    if (m1 > 0) {
        if (m2 > 0 && m1 < m2)
            return new Promise(resolve => setTimeout(resolve, lodash_1.random(m1, m2)));
        else
            return new Promise(resolve => setTimeout(resolve, m1));
    }
}
exports.Wait = Wait;
function WaitAtLeast(mili) {
    if (typeof mili === 'number') {
        const start = Date.now();
        return { resolve: () => mili - (Date.now() - start) };
    }
    else if (typeof mili === 'object' && mili.resolve) {
        const wait = mili.resolve();
        if (wait > 50)
            return Wait(wait);
    }
}
exports.WaitAtLeast = WaitAtLeast;
